var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"el-dropdown-menu__item screenfull-svg",on:{"click":_vm.click}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'expand-arrows-alt']}}),_vm._v("\n  Fullscreen\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }